export default __webpack_public_path__ + "static/media/sawmill.7b8e7867.svg";